"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONLY_WHITESPACES = exports.DUPLICATE = exports.TOO_LONG = exports.INVALID_CHARS = void 0;
var INVALID_CHARS = 'invalid_chars';
exports.INVALID_CHARS = INVALID_CHARS;
var TOO_LONG = 'too_long';
exports.TOO_LONG = TOO_LONG;
var DUPLICATE = 'duplicate';
exports.DUPLICATE = DUPLICATE;
var ONLY_WHITESPACES = 'only_whitespaces';
exports.ONLY_WHITESPACES = ONLY_WHITESPACES;